<template>
  <svg
    v-if="icon === 'file' || icon === 'file-application'"
    :width="width ? width : 17"
    :height="height ? height : 20"
    viewBox="0 0 17 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5 0V6C8.5 6.53043 8.72388 7.03914 9.1224 7.41421C9.52091 7.78929 10.0614 8 10.625 8H17V18C17 18.5304 16.7761 19.0391 16.3776 19.4142C15.9791 19.7893 15.4386 20 14.875 20H2.125C1.56141 20 1.02091 19.7893 0.622398 19.4142C0.223883 19.0391 0 18.5304 0 18V2C0 1.46957 0.223883 0.960859 0.622398 0.585786C1.02091 0.210714 1.56141 0 2.125 0H8.5ZM10.0938 0.5V6C10.0938 6.13261 10.1497 6.25979 10.2493 6.35355C10.349 6.44732 10.4841 6.5 10.625 6.5H16.4688L10.0938 0.5Z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'file-image'"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 460.002 460.002"
    style="enable-background: new 0 0 460.002 460.002"
    xml:space="preserve"
    :width="width ? width : 17"
    :height="height ? height : 20"
  >
    <g>
      <g>
        <path
          d="M427.137,0H32.865C14.743,0,0,14.743,0,32.865v408.543c0,10.253,8.341,18.594,18.594,18.594h408.543
			c18.122,0,32.865-14.743,32.865-32.865V32.865C460.002,14.743,445.259,0,427.137,0z M139.001,56.001c39.149,0,71,31.851,71,71
			s-31.851,71-71,71c-39.149,0-71-31.851-71-71C68.001,87.852,99.852,56.001,139.001,56.001z M405.24,393.215
			c-2.634,4.801-7.675,7.786-13.151,7.786H67.913c-5.477,0-10.518-2.984-13.151-7.786c-2.634-4.802-2.442-10.657,0.501-15.275
			l77.092-120.984c2.754-4.322,7.524-6.939,12.65-6.939s9.896,2.617,12.65,6.939l37.029,58.111l72.346-113.536
			c2.754-4.323,7.524-6.939,12.65-6.939c5.125,0,9.896,2.617,12.65,6.939L404.739,377.94
			C407.682,382.559,407.874,388.414,405.24,393.215z"
          :fill="color"
        />
      </g>
    </g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </svg>
  <svg
    v-else-if="icon === 'file-audio'"
    :width="width ? width : 17"
    :height="height ? height : 17"
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
  >
    <path
      :fill="color"
      d="M 41,65 41,1.4 89,11 89,86 c 0,0 -9,12 -28,5 -8,-3 -7,-12 2,-15 9,-3 15,-1 20,1 L 83,24 47,14 47,72 c 0,0 -5,14 -26,8 -7,-2 -11.8,-12 1,-16 7,-2 14,-2 19,1 z"
    />
  </svg>
  <svg
    v-else-if="icon === 'file-video'"
    :width="width ? width : 17"
    :height="height ? height : 17"
    viewBox="0 0 24 24"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="videoIconTitle"
    :stroke="color"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    fill="none"
    :color="color"
  >
    <title id="videoIconTitle">Video</title>
    <polygon points="18 12 9 16.9 9 7" />
    <circle cx="12" cy="12" r="10" />
  </svg>
</template>

<script>
export default {
  name: 'iconsButton',
  props: {
    icon: String,
    color: {
      type: String,
      default: '#F2F2F2',
    },
    width: {
      type: [Number, String],
      default: null,
    },
    height: {
      type: [Number, String],
      default: null,
    },
  },
}
</script>

<style scoped lang="scss">
.copy {
  polyline {
    animation: anim;
    animation-duration: 2s;
    animation-delay: 0.3s;
    animation-fill-mode: forwards;
    animation-timing-function: ease-out;

    -moz-animation: anim;
    -moz-animation-duration: 2s;
    -moz-animation-delay: 0.3s;
    -moz-animation-fill-mode: forwards;
    -moz-animation-timing-function: ease-out;
  }

  @keyframes anim {
    0% {
      stroke-dashoffset: 200;
    }
    50% {
      stroke-dashoffset: 50;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }
}

svg {
  path {
    transition: 0.3s !important;
  }
}
</style>
